import React from 'react';
import { Modal, Box, Grid, Typography, Button } from '@mui/material';

import useStyles from '../../../assets/styles/pages/ShopRequest';

import { ReactComponent as IconRequest } from '../../../assets/images/svg/shops/request/icon_pedido_enviar.svg';
import { ReactComponent as IconArrowRight } from '../../../assets/images/svg/shops/request/icon_seta_direita.svg';

interface Props {
  open: boolean;
  onClose: () => void;
  handleTypeDelivery: (type: number) => void;
}

const styleModalBottom = {
  position: 'absolute' as const,
  bottom: 0,
  width: '100%',
  maxWidth: 680,
  borderRadius: '32px 32px 0px 0px',
  p: '20px 20px 10px 20px',
  bgcolor: 'background.paper',
  outline: 'none',
};

export const TypeDeliveryModal = ({
  open,
  onClose,
  handleTypeDelivery,
}: Props): JSX.Element => {
  const classeStyle = useStyles();

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styleModalBottom}>
        <Grid container item xs={12} justifyContent="center">
          <IconRequest className={classeStyle.iconModal} />
        </Grid>
        <Grid container item xs={12} justifyContent="center">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h4"
            className={classeStyle.titleModal}
            style={{ fontWeight: '550' }}
          >
            Entrega
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2 }}
            className={classeStyle.textModal}
          >
            Quer receber o pedido na sua casa ou retirar no balcão do
            estabelecimento?
          </Typography>
        </Grid>

        <Grid
          container
          item
          justifyContent="flex-start"
          alignItems="center"
          textAlign="center"
        />
        <Button
          className={classeStyle.btnSubmit}
          variant="contained"
          onClick={() => handleTypeDelivery(1)}
        >
          Receber em casa
          <IconArrowRight className={classeStyle.iconArrow} />
        </Button>

        <Grid container item xs={12} justifyContent="center">
          <Button variant="text" onClick={() => handleTypeDelivery(2)}>
            <p className={classeStyle.textBtnKeepShopping}>Retirar no balcão</p>
          </Button>
        </Grid>
        <Grid container item xs={12} justifyContent="center">
          <Button onClick={onClose} variant="text">
            <p className={classeStyle.textBtnKeepShopping}>Fechar</p>
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
};
